import { Injectable } from '@angular/core';
import {AppSettings} from '../app-settings';


@Injectable()
export class ActivityListService {
  recentActivityActiveFlag:boolean = true;
  activityStatus = {
    "REVISION": {
      "Name": "Revision",
      "Image": "assets/images/revision.png",
      "editMenu": [
        {
          "Name": "In Progress",
          "Image": "assets/images/inprogress.png",
          "state": "INPROGRESS"

        }
      ]
    },
    "NEW": {
      "Name": "Not Started",
      "Image": "assets/images/not_attempted.png",
      "editMenu": [
      ]
    },
    "COMPLETED_AUTO": {
      "Name": "Completed",
      "Image": "assets/images/completed.png",
      "editMenu": [
        {
          "Name": "Revision",
          "Image": "assets/images/revision.png",
          "state": "REVISION"
        }
      ]
    },
    "INPROGRESS": {
      "Name": "Inprogress",
      "Image": "assets/images/inprogress.png",
      "editMenu": [
        {
          "Name": "Attempted",
          "Image": "assets/images/completed_user.png",
          "state": "COMPLETED_MANUAL"
        }
      ]
    },
    "COMPLETED_MANUAL": {
      "Name": "Marked as complete",
      "Image": "assets/images/completed_user.png",
      "editMenu": [
        {
          "Name": "Revision",
          "Image": "assets/images/revision.png",
          "state": "REVISION"
        }
      ]
    }
  };


  constructor() { }
  getData(data: any): any {
    data.humanEfforts = {};
    data.humanEfforts['paceHumanEfforts'] = 0;
    data.humanEfforts['nonPaceHumanEfforts'] = 0;
    data.humanEfforts['nonPaceRemainingHumanEfforts'] = 0;
    data.humanEfforts['paceRemainingHumanEfforts'] = 0;
    let courseCompletedTime = 0;
    if(data.topics){
    for (let i = 0; i < data.topics.length; i++) {
      data.topics[i].isVisible = false;
      data.topics[i].completionCount = 0;
      data.topics[i].totalActivities = data.topics[i].activities.length;
      for (let j = 0; j < data.topics[i].activities.length; j++) {
        if(data.topics[i].activities[j].quizType!=="INFOQUIZ")
        {
          data.humanEfforts.nonPaceHumanEfforts += data.topics[i].activities[j].recommendedCompeltionTimeInMins;
        }
        if (data.topics[i].activities[j].paceAction !== 'HIDE' && data.topics[i].activities[j].paceAction !== 'DEHIGHLIGHT' && data.topics[i].activities[j].quizType!=="INFOQUIZ")
        {
          if (data.topics[i].activities[j].userState.includes('COMPLETE')) {
                courseCompletedTime += data.topics[i].activities[j].recommendedCompeltionTimeInMins;
          }
          data.humanEfforts.paceHumanEfforts += data.topics[i].activities[j].recommendedCompeltionTimeInMins;
        }
        data.topics[i].activities[j].isEditVisible = false;
        if (data.topics[i].activities[j].isRecent === "YES") {
          data.topics[i].activities[j].activityColor = "#00aeef";
          if(data.topics[i].activities[j].timeSpent != null)
          {
            this.recentActivityActiveFlag = false;
          }
          else
          {
            this.recentActivityActiveFlag = true;
          }
        }
        var userState = data.topics[i].activities[j].userState;
        data.topics[i].activities[j].activityStatus = this.activityStatus[userState];
        data.topics[i].activities[j].activityStatusCount = this.activityStatus[userState].editMenu.length;
        data.topics[i].activities[j].statusImage = AppSettings.cdnUrl + this.activityStatus[userState].Image;
        data.topics[i].activities[j].statusText = this.activityStatus[userState].Name;
        data.topics[i].activities[j].isValidAccess = data.topics[i].activities[j].hasAccess;
        data.topics[i].activities[j].isArchived = data.topics[i].activities[j].archived;
        data.topics[i].activities[j].archivedMessage = data.topics[i].activities[j].archivedMessage;
        data.topics[i].activities[j].archiveTimestamp = data.topics[i].activities[j].archiveTimestamp;
        data.topics[i].activities[j].recommendedEffort = data.topics[i].activities[j].recommendedCompeltionTimeInMins;

        data.topics[i].activities[j].paceAction = data.topics[i].activities[j].paceAction;


        if (data.topics[i].activities[j].userState === "COMPLETED_AUTO" || data.topics[i].activities[j].userState === "COMPLETED_MANUAL" || data.topics[i].activities[j].userState === "REVISION") {
          data.topics[i].completionCount++;
        }


        /*

            if (data.topics[i].activities[j].isCompletedByUser=="yes")
            {
              data.topics[i].activities[j].activityStatus=this.activityStatus.COMPLETEDBYUSER;
              data.topics[i].activities[j].activityStatusCount=this.activityStatus.COMPLETEDBYUSER.editMenu.length;
              data.topics[i].activities[j].statusImage=AppSettings.cdnUrl+"assets/images/completed_user.png";
              data.topics[i].activities[j].statusText=this.activityStatus.COMPLETEDBYUSER.Name;
            }*/

        data.topics[i].activities[j].scorePercentage = data.topics[i].activities[j].userScore;

        if (data.topics[i].activities[j].userScore == null) {
          data.topics[i].activities[j].scorePercentage = -10;
          //validation case -10 negative means no score present
        }

/*
        if (data.topics[i].activities[j].totalScore == 0 || data.topics[i].activities[j].totalScore == null) {
          data.topics[i].activities[j].scorePercentage = -10;
          //validation case -10 negative means no score present
        }*/

        if (data.topics[i].activities[j].scorePercentage > 0 && data.topics[i].activities[j].scorePercentage <= 25) {
          data.topics[i].activities[j].starImage = AppSettings.cdnUrl + "assets/images/star_25.png";
        }
        else if (data.topics[i].activities[j].scorePercentage > 25 && data.topics[i].activities[j].scorePercentage <= 50) {
          data.topics[i].activities[j].starImage = AppSettings.cdnUrl + "assets/images/star_50.png";
        }
        else if (data.topics[i].activities[j].scorePercentage > 50 && data.topics[i].activities[j].scorePercentage <= 95) {
          data.topics[i].activities[j].starImage = AppSettings.cdnUrl + "assets/images/star_75.png";
        }
        else if (data.topics[i].activities[j].scorePercentage > 95) {
          data.topics[i].activities[j].starImage = AppSettings.cdnUrl + "assets/images/star_100.png";
        }
        else if (data.topics[i].activities[j].scorePercentage == 0) {
          data.topics[i].activities[j].starImage = AppSettings.cdnUrl + "assets/images/star_0.png";
        }

        data.topics[i].activities[j].minutes = Math.floor(data.topics[i].activities[j].timeSpent / 60);
        if (data.topics[i].activities[j].type === "HTML5") {

          if (data.topics[i].activities[j].isRecent === "YES") {
            data.topics[i].activities[j].imageIcon = AppSettings.cdnUrl + "assets/images/html5_icon_blue.png";
          }
          else {
            data.topics[i].activities[j].imageIcon = AppSettings.cdnUrl + "assets/images/html5_icon_grey.png";
          }



        }

        else if (data.topics[i].activities[j].type === "MIQA") {
          if (data.topics[i].activities[j].isRecent === "YES") {
            data.topics[i].activities[j].imageIcon = AppSettings.cdnUrl + "assets/images/miqa_quiz_blue.png";

          }
          else {
            data.topics[i].activities[j].imageIcon = AppSettings.cdnUrl + "assets/images/miqa_quiz_grey.png";
          }
        }
        else if (data.topics[i].activities[j].type === "RISE_ARTICLE" || data.topics[i].activities[j].type === "RISE_TINCAN" ) {
          if (data.topics[i].activities[j].isRecent === "YES") {
            data.topics[i].activities[j].imageIcon = AppSettings.cdnUrl + "assets/images/rise_blue.png";
            this.recentActivityActiveFlag = false;
          }
          else {
            data.topics[i].activities[j].imageIcon = AppSettings.cdnUrl + "assets/images/rise_grey.png";
          }
        }
        else if (data.topics[i].activities[j].type === "RISE_ADOBE_CONNECT") {
          if (data.topics[i].activities[j].isRecent === "YES") {
            data.topics[i].activities[j].imageIcon = AppSettings.cdnUrl + "assets/images/video-camera.png";
            this.recentActivityActiveFlag = false;
          }
          else {
            data.topics[i].activities[j].imageIcon = AppSettings.cdnUrl + "assets/images/video-camera.png";
          }
        }
      }


      if (data.topics[i].completionCount > 0) {
        data.topics[i].completionColor = "#4fbcf4";
      }
      data.topics[i].completionPercentage = data.topics[i].completionCount / data.topics[i].activities.length * 100;

      if (data.topics[i].completionCount / data.topics[i].activities.length === 1) {
        data.topics[i].totalCompletionColor = "#4fbcf4";
      }

    }
  } else {
    data.topics = null;
  }
    data.humanEfforts['paceRemainingHumanEfforts'] = data.humanEfforts['paceHumanEfforts'] - courseCompletedTime;
    data.humanEfforts['nonPaceRemainingHumanEfforts'] = data.humanEfforts['nonPaceHumanEfforts'] - courseCompletedTime;
    data.topics ? data.topics.humanEfforts = data.humanEfforts : null;
    return data.topics ? data.topics : data;
  }

  getRecentActivityActiveFlag()
  {
    return this.recentActivityActiveFlag;
  }

}
